"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    menuMargin: {
        marginTop: 25,
    },
    subMenuPadding: {
        width: '100%',
        paddingLeft: 25,
    },
    additionalMarginTop: {
        paddingTop: react_native_1.Platform.OS === 'web' ? 35 : 25,
    },
    iconTopMarginFix: {
        marginTop: 6,
        marginLeft: 5,
    },
    profileSelectedCategoryStyle: {
        backgroundColor: colors_1.default.COLOR_GRAY_LIGHTEST,
        borderRadius: 16,
    },
});
exports.default = styles;
